import { MIN_INVOICE_PRICE } from "@/main/domain/cancel"
import { isValidCancelTypeToSendInvoice } from "@/main/domain/home"
import { CancelForListFragment } from "@/main/gql/__generated__/graphql"
import { isValidPhoneNumber } from "@/utils/phoneNumber"

export type ClaimValidationResult = {
	reasons: string[]
	invalidPhone: boolean
	invalidCancelType: boolean
	insufficientPrice: boolean
}

export const validateClaimability = (
	cancel: CancelForListFragment
): ClaimValidationResult => {
	const reasons: string[] = []
	const invalidPhone = !isValidPhoneNumber(cancel.phoneNumber)
	if (invalidPhone) reasons.push("電話番号不正")
	const invalidCancelType = !isValidCancelTypeToSendInvoice(cancel.cancelType)
	if (invalidCancelType) reasons.push("キャンセル種別未設定")
	const insufficientPrice = cancel.invoicePrice < MIN_INVOICE_PRICE
	if (insufficientPrice) reasons.push("金額不足")
	return { reasons, invalidPhone, invalidCancelType, insufficientPrice }
}

export const isUnclaimableCancel = (cancel: CancelForListFragment): boolean => {
	return validateClaimability(cancel).reasons.length > 0
}
